export default /* @ngInject */($sce) => $sce.trustAsHtml;
